import angular from 'angular';
import template from './sectionTableWrapper.html';
import './sectionTableWrapper.scss';

export class SectionTableWrapper {
  constructor(locationUtils) {
    'ngInject';

    this.locationUtils = locationUtils;
  }
  $onInit() {
    this.showSearch = angular.isUndefined(this.showSearch) ? true : this.showSearch;
  }
  search(text) {
    this.onSearch({ text });
  }
  toggleList() {
    this.onToggle({ select: this.toggleAll });
  }
}

export default {
  controller: SectionTableWrapper,
  template,
  bindings: {
    tableTitle: '@',
    tableTabs: '<',
    onSearch: '&',
    onToggle: '&',
    searchDebounce: '@',
    toggleAll: '<',
    disableToggle: '<',
    showFooter: '<',
    showSearch: '<',
  },
  transclude: {
    body: 'sectionTableWrapperBody',
    footerActions: '?sectionTableWrapperFooterActions',
  },
};
